import React from 'react'
import { Form, Typography, Col, Select, Radio, Row } from 'antd'
import { disdette } from '../assets/constants'
import _ from 'lodash'

const Regole = (props) => {
  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
  }
  return (
    <>
      <Typography.Title>Quali sono le regole della casa?</Typography.Title>
      <Col xs={24} lg={8}>
        <Row>
          <Form.Item
            name="disdette"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select placeholder="Seleziona un periodo di disdetta">
              {_.map(disdette, (item, index) => (
                <Select.Option key={`disdette_${index}`} value={item.value}>
                  <Typography.Text>{item.label}</Typography.Text>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Row>
      </Col>
      <input type="hidden" name="refunded" value="1" />
      <span className="text-xl">Sono consentiti animali (opzionale)</span>
      <Form.Item name="animali">
        <Radio.Group value={props.formValue.animali} className="text-xl">
          <Radio style={radioStyle} value={0}>
            No, è vietato introdurre animali
          </Radio>
          <Radio style={radioStyle} value={1}>
            Sì
          </Radio>
        </Radio.Group>
      </Form.Item>
    </>
  )
}

export default Regole
